import {
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Cancel, Edit, Lock, Security, VerifiedUser } from "@material-ui/icons";
import { useEffect, useRef, useState } from "react";
import AdminUserForm from "../../components/adminUserForm/AdminUserForm";
import PasswordForm from "../../components/passwordForm/PasswordForm";
import UserRoleForm from "../../components/userRoleForm/UserRoleForm";
import { useFetch } from "../../features/customHooks/useFetch";
import { useSnackbar } from "notistack";
import { useStyles } from "./users.styles";

const Users = (props) => {
  const classes = useStyles();

  const { enqueueSnackbar } = useSnackbar();
  const [type, setType] = useState("filtered");

  const editUserFormRef = useRef(null);
  const editPassFormRef = useRef(null);
  const editRoleFormRef = useRef(null);

  const [editUser, setEditUser] = useState({ open: false, user: null });
  const [editPass, setEditPass] = useState({ open: false, user: null });
  const [editRole, setEditRole] = useState({ open: false, user: null });

  const [getFetchState, setGetFetchParams] = useFetch();
  const [editUserFetchState, setEditUserFetchParams] = useFetch();
  const [editPassFetchState, setEditPassFetchParams] = useFetch();
  const [editRoleFetchState, setEditRoleFetchParams] = useFetch();

  const getUsers = () => {
    var data = {};

    data["type"] = type;

    const params = {
      method: "get",
      url: "/users",
      data: { ...data },
      headers: { "Content-Type": "multipart/form-data" },
    };
    setGetFetchParams(params);
  };

  const handleEditUser = (data) => {
    delete data.id;
    delete data.role;
    const params = {
      data: data,
      method: "put",
      url: `/users/${editUser?.user?.id}`,
    };
    setEditUserFetchParams(params);
  };

  const handleEditPass = (data) => {
    const params = {
      data: data,
      method: "put",
      url: `/users/change_pass/${editPass?.user}`,
    };
    setEditPassFetchParams(params);
  };

  const handleEditRole = (data) => {
    data.role = data.role.id;
    const params = {
      data: data,
      method: "put",
      url: `/users/${editRole?.user}`,
    };
    setEditUserFetchParams(params);
  };

  const getUserRole = (role) => {
    switch (role) {
      case "user":
        return "کاربر";
      case "global_limited_user":
        return "کاربر بدون دسترسی عمومی";
      case "not_verified":
        return "تایید نشده";
      case "admin":
        return "مدیر";
      default:
        return "نا مشخص";
    }
  };

  const getUserRoleVariant = (role) => {
    switch (role) {
      case "user":
      case "global_limited_user":
        return "outlined";
      case "not_verified":
        return undefined;
      case "admin":
        return "default";
      default:
        return "default";
    }
  };

  const getUserRoleColor = (role) => {
    switch (role) {
      case "user":
      case "global_limited_user":
        return "secondary";
      case "admin":
        return "primary";
      case "not_verified":
      default:
        return "default";
    }
  };

  const nullHandler = (data) => data;

  useEffect(() => {
    getUsers();
  }, [type]);

  useEffect(() => {
    if (!editUserFetchState.loading && !editUserFetchState.error && editUserFetchState.data) {
      enqueueSnackbar("عملیات با موفقیت انجام شد!", { variant: "success" });
      setEditUser({ open: false, user: null });
      setEditRole({ open: false, user: null });
      getUsers();
    }

    if (!editUserFetchState.loading && editUserFetchState.error)
      enqueueSnackbar("خطا در انجام عملیات!", { variant: "error" });
  }, [editUserFetchState]);

  useEffect(() => {
    if (!editPassFetchState.loading && !editPassFetchState.error && editPassFetchState.data) {
      enqueueSnackbar("عملیات با موفقیت انجام شد!", { variant: "success" });
      setEditPass({ open: false, user: null });
    }

    if (!editPassFetchState.loading && editPassFetchState.error)
      enqueueSnackbar("خطا در انجام عملیات!", { variant: "error" });
  }, [editPassFetchState]);

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Grid container justifyContent='flex-start' alignItems='center'>
          <Typography className={classes.titleTypo}>کاربرها</Typography>
          <Chip
            color={type === "filtered" ? "primary" : "secondary"}
            variant={type === "filtered" ? "default" : "outlined"}
            label='فیلتر شده'
            onClick={() => {
              setType("filtered");
            }}
            style={{ marginLeft: 10 }}
          />

          <Chip
            color={type === "all" ? "primary" : "secondary"}
            variant={type === "all" ? "default" : "outlined"}
            label='همه'
            onClick={() => {
              setType("all");
            }}
          />
          <div className={classes.flexGrow} />
        </Grid>
        <Paper style={{ overflow: "hidden", marginTop: 20, position: "relative" }}>
          {getFetchState.loading && (
            <Grid
              container
              alignItems='center'
              justifyContent='center'
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 1000,
                // backdropFilter: "blur(5px)",
                backgroundColor: "#ffffff77",
                pointerEvents: "none",
              }}
            >
              <CircularProgress />
            </Grid>
          )}
          <Grid
            container
            style={{
              // overflow: orders.isFetching ? "hidden" : "auto",
              overflow: "auto",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "0px",
                height: "500px",
              }}
            >
              <Table aria-label='simple table' stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>عملیات</TableCell>
                    <TableCell>وضعیت</TableCell>
                    <TableCell>نام</TableCell>
                    <TableCell>نام خانوادگی</TableCell>
                    <TableCell>نام کاربری</TableCell>
                    <TableCell>شماره تماس</TableCell>
                    <TableCell>عنوان</TableCell>
                    <TableCell>شماره ثابت</TableCell>
                    <TableCell>آدرس</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {getFetchState?.data?.data?.map((user, index) => (
                    <TableRow
                      key={user?.id}
                      style={{
                        // "&:last-child td, &:last-child th": { border: 0 },
                        "td, th": { border: 0 },
                        td: { backgroundColor: index % 2 === 0 ? "#7165e311" : "transparent" },
                      }}
                    >
                      <TableCell>
                        <Grid container wrap='nowrap' spacing={1}>
                          <Grid item>
                            <Tooltip title='ویرایش'>
                              <IconButton size='small' onClick={() => setEditUser({ open: true, user: user })}>
                                <Edit />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                          <Grid item>
                            <Tooltip title='تغییر رمز عبور'>
                              <IconButton size='small' onClick={() => setEditPass({ open: true, user: user?.id })}>
                                <Lock />
                              </IconButton>
                            </Tooltip>
                          </Grid>

                          <Grid item>
                            <Tooltip title='تغییر دسترسی' onClick={() => setEditRole({ open: true, user: user?.id })}>
                              <IconButton size='small'>
                                <Security />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </TableCell>
                      <TableCell align='center'>
                        <Chip
                          size='small'
                          variant={getUserRoleVariant(user?.role)}
                          color={getUserRoleColor(user?.role)}
                          label={nullHandler(getUserRole(user.role))}
                        />
                      </TableCell>
                      <TableCell>{nullHandler(user?.first_name)?.toString()?.toPersianDigits()}</TableCell>
                      <TableCell>{nullHandler(user?.last_name)?.toString()?.toPersianDigits()}</TableCell>
                      <TableCell>{nullHandler(user?.username)?.toString()?.toPersianDigits()}</TableCell>
                      <TableCell>{nullHandler(user?.phone_number)?.toString()?.toPersianDigits()}</TableCell>
                      <TableCell>{nullHandler(user?.work_title)?.toString()?.toPersianDigits()}</TableCell>
                      <TableCell>{nullHandler(user?.work_number)?.toString()?.toPersianDigits()}</TableCell>
                      <TableCell>{nullHandler(user?.work_address)?.toString()?.toPersianDigits()}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Grid>
        </Paper>

        <Dialog
          open={editUser?.open}
          onClose={() => setEditUser({ open: false, user: null })}
          style={{ padding: 10 }}
          fullWidth
        >
          <DialogTitle>ویرایش کاربر</DialogTitle>
          <DialogContent>
            <AdminUserForm
              onSubmitForm={handleEditUser}
              ref={editUserFormRef}
              loading={editUserFetchState?.loading}
              defaultValues={editUser.user}
            />
          </DialogContent>
          <DialogActions>
            <Button
              disabled={editUserFetchState?.loading}
              onClick={() => setEditUser({ open: false, user: null })}
              variant='text'
              color='primary'
            >
              لغو
            </Button>
            <Button
              disabled={editUserFetchState?.loading}
              onClick={() => editUserFormRef?.current?.submit()}
              color='secondary'
              variant='contained'
            >
              {editUserFetchState?.loading ? <CircularProgress size={24} /> : "ویرایش کاربر"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={editPass?.open}
          onClose={() => setEditPass({ open: false, user: null })}
          style={{ padding: 10 }}
          maxWidth={"xs"}
          fullWidth
        >
          <DialogTitle>تغییر رمز عبور</DialogTitle>
          <DialogContent>
            <PasswordForm onSubmitForm={handleEditPass} ref={editPassFormRef} loading={editPassFetchState?.loading} />
          </DialogContent>
          <DialogActions>
            <Button
              disabled={editPassFetchState?.loading}
              onClick={() => setEditPass({ open: false, user: null })}
              variant='text'
              color='primary'
            >
              لغو
            </Button>
            <Button
              disabled={editPassFetchState?.loading}
              onClick={() => editPassFormRef?.current?.submit()}
              color='secondary'
              variant='contained'
            >
              {editUserFetchState?.loading ? <CircularProgress size={24} /> : "ویرایش رمز عبور"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={editRole?.open}
          onClose={() => setEditRole({ open: false, user: null })}
          style={{ padding: 10 }}
          maxWidth={"xs"}
          fullWidth
        >
          <DialogTitle>تغییر سطح دسترسی</DialogTitle>
          <DialogContent>
            <UserRoleForm onSubmitForm={handleEditRole} ref={editRoleFormRef} loading={editRoleFetchState?.loading} />
          </DialogContent>
          <DialogActions>
            <Button
              disabled={editRoleFetchState?.loading}
              onClick={() => setEditRole({ open: false, user: null })}
              variant='text'
              color='primary'
            >
              لغو
            </Button>
            <Button
              disabled={editRoleFetchState?.loading}
              onClick={() => editRoleFormRef?.current?.submit()}
              color='secondary'
              variant='contained'
            >
              {editRoleFetchState?.loading ? <CircularProgress size={24} /> : "ویرایش دسترسی"}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default Users;
